import strFunc from '@/lib/lyg/string';
import ColorFunc from "@/pcomponents/common/content/todo/color/func/color_func";
import TodoStateFunc from "@/pcomponents/common/content/todo/state/func/state_func";
import DailyReportDataFunc from "@/pcomponents/common/content/edu/daily_report/func/data_func";

function GroupTitleRow(props: any) {
  let myProps = {
    Style: {},
    color_json: {},
    info: {},
    sort: "",
    sort_title: "",
    subject_name: "",
    base_date_str: "",
    pre_date_str: "",
    daily_info: null,
    row_item: {},
    title: "",
    openTodoDaySort: (inData: any) => { },
    ...props
  };
  let Style = myProps.Style;
  let info = myProps.info;
  let pre_date_str = myProps.pre_date_str;
  let base_date_str = myProps.base_date_str;
  let subject_name = myProps.subject_name;
  let daily_info = myProps.daily_info;
  let row_item = myProps.row_item;
  if (row_item.subject_data_json && subject_name && row_item.subject_data_json[subject_name]) {
    row_item = { ...row_item.subject_data_json[subject_name] };
  }

  let color_json: any = ColorFunc.get_color_style_of_percent(row_item.percent);
  let todo_cnt_str = "";
  if (row_item.count) {
    todo_cnt_str = "( " + row_item.success_cnt + "/" + row_item.count + " )";
  }

  let todo_time_his = strFunc.secondsToTimeJson(parseInt(strFunc.uncomma(row_item.elapse_time_sec)));
  let time_str = strFunc.timeJsonToTimeStr(todo_time_his);

  let work_file_span: any = "";
  let row_file_cnt = TodoStateFunc.get_file_cnt_by_user_info({
    info: info,
    date_sort: row_item.sort == "pre_homework" ? "pre" : "now",//pre,now
    select_date: base_date_str,
    pre_date_str: pre_date_str,
    file_sort: row_item.sort == "pre_homework" ? "homework" : row_item.sort,//homework,study
    subject_name: subject_name,
  });
  row_file_cnt += row_item.file_cnt;
  if (row_file_cnt > 0) {
    work_file_span = (
      <span className={Style.mid_todo_row_home_work_file_ico}>
        {row_file_cnt}
      </span>
    );
  }

  let row_home_work_state = "";
  let row_home_work_state_style:any = {
    fontWeight: 200,
    color: "#fff",
    display: "inline-block",
    minWidth:"20px",
    borderRadius: "50%",
    background:"#999",
    textAlign: "center",
  };
  if (daily_info && daily_info["a_homework_state"]) {
    let show_daily_info_arr = DailyReportDataFunc.get_show_info_arr({
      infoArr: [daily_info]
    });
    let home_work_state_val="";
    if(row_item.sort == "pre_homework"){
      row_home_work_state = show_daily_info_arr[0]["a_homework_state"];
      home_work_state_val=daily_info["a_homework_state"];
    }else if(row_item.sort == "study"){
      row_home_work_state = show_daily_info_arr[0]["a_study_state"];
      home_work_state_val=daily_info["a_study_state"];
    }
    if(home_work_state_val=="1"){
      row_home_work_state_style["background"] = "#a2b854";
    }else if(home_work_state_val=="2"){
      row_home_work_state_style["background"] = "#db6c58";
    }else if(home_work_state_val=="3"){
      row_home_work_state_style["background"] = "#eab358";
    }
  }

  return (
    <div className={Style.mid_todo_row} style={color_json.wrap}
      onClick={() => {
        myProps.openTodoDaySort({
          select_stu_name: info.a_user_name,
          select_stu_seq: info.a_seq,
          select_date: (myProps.sort == "pre_homework" ? pre_date_str : base_date_str),
          subject_name: subject_name,
        });
      }}>
      <div className={Style.mid_todo_row_bar} style={color_json.bar}></div>
      <span className={Style.mid_todo_row_title}>
        {myProps.title}
        <span className="ml-1">{myProps.sort_title}</span>
        {todo_cnt_str}
        {!strFunc.is_empty(row_item.elapse_time_sec) &&
          <span style={{ fontSize: "12px", marginLeft: 5, color: "#666" }}>
            {time_str}
          </span>
        }
        {work_file_span}
      </span>
      {row_home_work_state &&
        <span className="ml-2" style={row_home_work_state_style}>{row_home_work_state}</span>
      }
      <span className={Style.mid_todo_row_per}>
        {row_item.percent}%
      </span>
    </div>
  );
};
export default GroupTitleRow;